export default {
    latest_info: "Welcome to Wizarr, you can always find the latest information about Wizarr here!",
    thank_you: "Thank you message has not been loaded from the remote configuration, please wait a few hours and try again.",
};
